(ns entities.liabilities.events
  (:require
    [very.re-frame.core :as rf]
    [entities.liabilities.specs :as sp]
    [graphql.core :as qu]
    )
  )

(def path [:entities :liabilities])

(rf/reg-entity
  :liabilities
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/liabilities)
                :success [:liabilities/fetched]
                :error [:liabilities/fetch-errored]
                :cancellable? true}})

   :patch
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/update-liabilities {:input {:liabilities data}})
                :success [:liabilities/updated]
                :error [:liabilities/update-errored]}})

   :spec/patch ::sp/patch})

(rf/reg-event-db
  :liabilities/fetched
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:client :additional-liabilities])))

(rf/reg-event-db
  :liabilities/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:client :additional-liabilities])))

(rf/reg-event-db
  :liabilities/updated
  (rf/path path)
  (fn [_ [data]]
    (:update-liabilities data)))

(rf/reg-event-db
  :liabilities/updated-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (:update-liabilities data)))
